<template>
    <span v-b-tooltip.html.hover :title="tooltip">
        <b-button
            class="mr-2"
            :disabled="disabled"
            :variant="variantBotao"
            @click.stop="abrirModal()"
        >
            <i :class="classeIconeBotao"></i> {{ textoBotao }}
        </b-button>

        <b-modal v-model="mostrarModal" @hidden="fecharModal()" size="md" no-close-on-backdrop>
            <div slot="modal-title">{{ titulo }}</div>

            <b-row v-if="ehEtapaDevolucaoFornecedor && etapa != etapaBoletimMedicaoEnum.ReinicioProcesso">
                <b-col>
                    <b-form-group>
                        <label :class="campoObrigatorio">Motivo:</label>
                        <b-form-select
                            :plain="true"
                            :options="motivosDevolucaoAnaliseBoletimMedicao"
                            v-model="motivoDevolucao"
                            text-field="descricao"
                            value-field="id"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="etapa == etapaBoletimMedicaoEnum.ReinicioProcesso">
                <b-col>
                    <b-form-group>
                        <label :class="campoObrigatorio">Etapa para reinicio:</label>
                        <b-form-select
                            :plain="true"
                            :options="etapasReinicioBoletimMedicao"
                            v-model="etapaReinicioProcesso"
                            text-field="descricaoReinicioAnalise"
                            value-field="id"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="etapa == etapaBoletimMedicaoEnum.CadastroRequisicao">
                <b-col>
                    <b-form-group>
                        <label class="required">Número Processo:</label>
                        <b-form-input
                            v-model="numeroProcesso"
                            v-mask="'##########.######/####-##'"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="ehEtapaEnvioNotaFiscal">
                <b-col>
                    <b-form-group>
                        <label class="required">Nota Fiscal:</label>
                        <b-form-file
                            ref="selecaoArquivoNotaFiscal"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecionar"
                            accept=".pdf,.jpg,.jpeg,.png"
                            @change="selecionarArquivoNotaFiscal"
                        ></b-form-file>
                    </b-form-group>

                    <b-button-group v-for="(anexo, index) in anexos" :key="index" class="m-1">
                        <b-button variant="light" disabled>
                            {{ anexo.nome }} ({{ anexo.tamanho | tamanhoArquivoFormatado }})
                        </b-button>
                        <b-button variant="light" @click="removerAnexo(index)" v-b-tooltip.hover title="Clique para remover">
                            <i class="fa fa-times text-danger"></i>
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label :class="campoObrigatorio">Observação:
                            <span v-if="!ehEtapaDevolucaoFornecedor && etapa != etapaBoletimMedicaoEnum.ReinicioProcesso" class="text-muted">(Opcional)</span>
                        </label>
                        <b-form-textarea
                            v-model="observacao"
                            rows="3"
                            max-rows="6"
                            :no-resize="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="ehDevolucaoBoletimMedicaoPrincipal">
                <b-col>
                    <b-form-group>
                        <label>O que precisa ser corrigido:</label>
                        <b-form-checkbox v-model="plantaFaladaEditavel">
                            Planta Falada deve ser repreenchida
                        </b-form-checkbox>
                        <b-form-checkbox v-model="declaracaoVinculoEditavel">
                            Declaração de Vínculo deve ser repreenchida
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="ehEtapaDevolucaoFornecedor">
                <b-col>
                    <b-form-group>
                        <label>Anexos: <span class="text-muted">(Opcional)</span></label>
                        <b-form-file
                            ref="selecaoArquivo"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecionar"
                            accept=".jpg,.jpeg,.png,.pdf,.docx"
                            @change="selecionarArquivo"
                        ></b-form-file>
                    </b-form-group>

                    <b-button-group v-for="(anexo, index) in anexos" :key="index" class="m-1">
                        <b-button variant="light" disabled>
                            {{ anexo.nome }} ({{ anexo.tamanho | tamanhoArquivoFormatado }})
                        </b-button>
                        <b-button variant="light" @click="anexos.splice(index, 1)" v-b-tooltip.hover title="Clique para remover">
                            <i class="fa fa-trash text-danger"></i>
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button
                    ref="btnCancelar"
                    class="mr-2"
                    variant="secondary"
                    @click.stop="fecharModal()"
                >Cancelar</b-button>

                <b-button
                    ref="btnConfirmar"
                    variant="primary"
                    :disabled="btnConfirmarDisabled"
                    @click.stop="confirmar()"
                >Confirmar</b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>

import {
    motivosDevolucaoAnaliseBoletimMedicao,
    etapaBoletimMedicaoEnum,
    etapaBoletimMedicao,
} from '../../boletinsMedicoes/BoletimMedicao.js';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        textoBotao: {
            type: String,
            default: '',
        },
        iconeBotao: {
            type: String,
            default: '',
        },
        titulo: {
            type: String,
            default: '',
        },
        etapa: {
            type: Number,
            default: 0,
        },
        variantBotao: {
            type: String,
            default: 'primary',
        },
        mensagemConfirmacao: {
            type: String,
            default: '',
        },
        tooltip: {
            type: String,
            default: '',
        },
        itensAprovados: {
            type: Array,
            default: () => [],
        },
        totalItens: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            motivosDevolucaoAnaliseBoletimMedicao: motivosDevolucaoAnaliseBoletimMedicao,
            etapaBoletimMedicaoEnum: etapaBoletimMedicaoEnum,
            etapaReinicioProcesso: null,
            mostrarModal: false,
            observacao: null,
            motivoDevolucao: null,
            ehEtapaDevolucaoFornecedor: false,
            numeroProcesso: null,
            anexos: [],
            plantaFaladaEditavel: false,
            declaracaoVinculoEditavel: false,
            memoriaCalculoEditavel: false,
            cronogramaEditavel: false,
            curvaSEditavel: false,
            planilhaMedicaoEditavel: false,
        }
    },

    computed: {
        campoObrigatorio() {
            return this.ehEtapaDevolucaoFornecedor || this.etapa == etapaBoletimMedicaoEnum.ReinicioProcesso ? 'required' : '';
        },

        classeIconeBotao() {
            return this.iconeBotao ? `fa ${this.iconeBotao} mr-2` : '';
        },

        ehDevolucaoBoletimMedicaoPrincipal() {
            return this.etapa === etapaBoletimMedicaoEnum.DevolucaoBoletimMedicaoParaCorrecao;
        },

        ehEtapaEnvioNotaFiscal() {
            return this.etapa === etapaBoletimMedicaoEnum.EnvioNotaFiscalParaAprovacao;
        },

        temAjusteSelecionado() {
            return this.itensAprovados.length < this.totalItens
                || this.planilhaMedicaoEditavel
                || this.plantaFaladaEditavel
                || this.declaracaoVinculoEditavel
                || this.memoriaCalculoEditavel
                || this.cronogramaEditavel
                || this.curvaSEditavel;
        },

        btnConfirmarDisabled() {
            if (this.ehEtapaDevolucaoFornecedor) {
                if (this.ehDevolucaoBoletimMedicaoPrincipal) {
                    return !this.observacao || !this.motivoDevolucao || !this.temAjusteSelecionado;
                }
                return !this.observacao || !this.motivoDevolucao
            } else if (this.etapa == etapaBoletimMedicaoEnum.ReinicioProcesso) {
                return !this.etapaReinicioProcesso || !this.observacao
            } else if (this.etapa == etapaBoletimMedicaoEnum.CadastroRequisicao) {
                const regex = /^\d{10}\.\d{6}\/\d{4}-\d{2}$/;
                return !regex.test(this.numeroProcesso);
            } else if (this.ehEtapaEnvioNotaFiscal) {
                return this.anexos.length === 0;
            }
            return false;
        },

        etapasReinicioBoletimMedicao() {
            return etapaBoletimMedicao.filter(item => item.reinicioAnalise);
        },
    },

    methods: {
        limparCampos() {
            this.observacao = null
            this.motivoDevolucao = null
            this.etapaReinicioProcesso = null
            this.anexos = []
            this.numeroProcesso = null
            this.plantaFaladaEditavel = false
            this.declaracaoVinculoEditavel = false
            this.memoriaCalculoEditavel = false
            this.cronogramaEditavel = false
            this.curvaSEditavel = false
            this.planilhaMedicaoEditavel = false
        },

        abrirModal() {
            this.limparCampos()
            this.mostrarModal = true
        },

        fecharModal() {
            this.$refs.btnCancelar.blur()
            this.mostrarModal = false
        },

        confirmar() {
            this.$swal({
                title: 'Atenção',
                html: `${this.mensagemConfirmacao}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                this.$refs.btnConfirmar.blur()

                if (result.value) {
                    this.concluirEtapa()
                }
            })
        },

        selecionarArquivo(event) {
            this.adicionarArquivo(event, ['.jpg', '.jpeg', '.png', '.pdf', '.docx'], 10 * 1024 * 1024, 'selecaoArquivo');
        },

        selecionarArquivoNotaFiscal(event) {
            this.adicionarArquivo(event, ['.pdf', '.jpg', '.jpeg', '.png'], 15 * 1024 * 1024, 'selecaoArquivoNotaFiscal');
        },

        adicionarArquivo(event, extensoesPermitidas, tamanhoMaximoBytes, refInput, substituirExistentes = false) {
            if (!(event.target.files && event.target.files.length > 0)) {
                this.anexo = null
                return
            }

            const arquivoSelecionado = event.target.files[0]
            const nomeArquivo = (arquivoSelecionado.name || '').toLowerCase()
            const extensao = nomeArquivo.includes('.') ? nomeArquivo.substring(nomeArquivo.lastIndexOf('.')) : ''

            if (!extensoesPermitidas.includes(extensao)) {
                this.$refs[refInput].reset()
                this.$toast.error(
                    `Extensão não permitida. Extensões aceitas: ${extensoesPermitidas.join(', ')}`,
                    'Erro',
                    this.$toastConfig.error
                )
                return
            }

            if (arquivoSelecionado.size > tamanhoMaximoBytes) {
                this.$refs[refInput].reset()
                this.$toast.error(
                    `O tamanho máximo permitido para um arquivo é ${Math.floor(tamanhoMaximoBytes / (1024 * 1024))} MB`,
                    'Erro',
                    this.$toastConfig.error
                )
                return
            }

            this.anexo = {
                nome: arquivoSelecionado.name,
                arquivo: arquivoSelecionado,
                data: new Date().toLocaleDateString(),
                tamanho: arquivoSelecionado.size
            }

            if (substituirExistentes) {
                this.anexos = [this.anexo]
            } else {
                this.anexos.push(this.anexo)
            }

            this.$refs[refInput].reset()
        },

        removerAnexo(index) {
            this.anexos.splice(index, 1)
        },

        concluirEtapa() {

             let dto = {
                etapa: this.etapa,
                etapaReinicioProcesso: this.etapaReinicioProcesso ?? null,
                observacao: this.observacao ?? null,
                motivoDevolucao: this.motivoDevolucao ?? null,
                anexos: this.anexos ?? null,
                numeroProcesso: this.numeroProcesso ?? null,
                itensAprovados: this.itensAprovados ?? [],
                plantaFaladaEditavel: this.plantaFaladaEditavel,
                declaracaoVinculoEditavel: this.declaracaoVinculoEditavel,
                memoriaCalculoEditavel: this.memoriaCalculoEditavel,
                cronogramaEditavel: this.cronogramaEditavel,
                curvaSEditavel: this.curvaSEditavel,
                planilhaMedicaoEditavel: this.planilhaMedicaoEditavel,
            }

            this.$emit('concluirEtapa', dto)
            this.fecharModal()
        },
    },

    updated() {
        this.ehEtapaDevolucaoFornecedor =
            this.etapa == etapaBoletimMedicaoEnum.DevolucaoBoletimMedicaoParaCorrecao ||
            this.etapa == etapaBoletimMedicaoEnum.DevolucaoNotaFiscalParaCorrecao
    }
}
</script>
